export const readOnlyRowsSetup = [
  [
    { colKey: 'categoryLabel', colSize: '4', header: 'Tipo', value: '' }
  ],
  [
    { colKey: 'name', colSize: '6', header: 'Nome', value: '' },
    { colKey: 'path', colSize: '6', header: 'Caminho', value: '' }
  ]
];